import { render, staticRenderFns } from "./child-list.vue?vue&type=template&id=70267667&scoped=true&"
import script from "./child-list.vue?vue&type=script&lang=js&"
export * from "./child-list.vue?vue&type=script&lang=js&"
import style0 from "./child-list.vue?vue&type=style&index=0&id=70267667&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70267667",
  null
  
)

export default component.exports